var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M10.5 2.5H10V7H8V2.5H1.75v13h14.5v-13H10.5zM7 13H4.25v-.5H7v.5zm9.75 3H1.25V2h15.5v14z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }